// Formatting. Money arrives as integer paise and is only divided at display.

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

/**
 * decimals: false → whole rupees; true → always 2dp (legal documents);
 * 'auto' → 2dp only where there are paise, so a tax figure is never silently
 * rounded but a round retainer carries no noise.
 */
export function inr(paise: number, decimals: boolean | 'auto' = false, symbol = true): string {
  const neg = paise < 0;
  const p = Math.abs(Math.round(paise || 0));
  const show = decimals === 'auto' ? p % 100 !== 0 : Boolean(decimals);
  const s = (p / 100).toLocaleString('en-IN', {
    minimumFractionDigits: show ? 2 : 0,
    maximumFractionDigits: show ? 2 : 0,
  });
  return `${neg ? '−' : ''}${symbol ? '₹' : ''}${s}`;
}

/** Lakh / crore short form, for dashboards. */
export function short(paise: number): string {
  const neg = paise < 0;
  const v = Math.abs(paise || 0) / 100;
  const sign = neg ? '−' : '';
  if (v >= 1e7) return `${sign}₹${(v / 1e7).toFixed(2)} Cr`;
  if (v >= 1e5) return `${sign}₹${(v / 1e5).toFixed(2)} L`;
  return `${sign}₹${Math.round(v).toLocaleString('en-IN')}`;
}

export const pct = (x: number, dp = 1) => `${(x * 100).toFixed(dp)}%`;

export function date(s?: string | null): string {
  if (!s) return '—';
  const [y, m, d] = s.slice(0, 10).split('-');
  return `${Number(d)} ${MONTHS[Number(m) - 1]} ${y}`;
}

export function monthLabel(ym?: string | null): string {
  if (!ym) return '—';
  const [y, m] = ym.split('-');
  return `${MONTHS[Number(m) - 1]} ${y}`;
}

export const today = () => new Date().toISOString().slice(0, 10);

/** Money in a foreign currency keeps its own symbol; INR uses Indian grouping. */
export function money(paise: number, currency = 'INR', decimals: boolean | 'auto' = false): string {
  if (currency === 'INR') return inr(paise, decimals);
  const sym = currency === 'USD' ? '$' : currency === 'GBP' ? '£' : `${currency} `;
  return `${sym}${(paise / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Series colour for a service line, falling through the eight validated slots. */
const SLOTS = ['--color-s1','--color-s2','--color-s3','--color-s4',
               '--color-s5','--color-s6','--color-s7','--color-s8'];
export const slotColour = (i: number) => `var(${SLOTS[i % SLOTS.length]})`;
